export type Bi = { fr: string; en: string }

export const ATNA_OFFICIAL_LOGO =
  'https://cdn.magicpatterns.com/uploads/6HXNZewGpXHjkabLCYinNN/Logo_ATNA_(14)_(1).png'

export const atnaFinalCtaCopy = {
  eyebrow: { fr: 'ATNA — INTELLIGENCE AGENTIQUE', en: 'ATNA — AGENTIC INTELLIGENCE' },
  headline: [
    { text: { fr: 'Combien de capacité', en: 'How much capacity' }, accent: false },
    { text: { fr: 'pourriez-vous libérer', en: 'could you free up' }, accent: false },
    { text: { fr: 'dans votre organisation ?', en: 'in your organization?' }, accent: true },
  ],
  body: [
    { fr: 'Une même intelligence, reliée à votre contexte,', en: 'One shared intelligence, connected to your context,' },
    { fr: 'à vos services et à vos opérations — pour aider vos équipes', en: 'your services and your operations — to help your teams' },
    { fr: 'à en faire davantage avec moins de friction.', en: 'do more with less friction.' },
  ],
  cta: { fr: 'Demander une démo', en: 'Request a demo' },
  coreLabel: [
    { fr: 'INTELLIGENCE', en: 'AGENTIC' },
    { fr: 'AGENTIQUE', en: 'INTELLIGENCE' },
  ],
  foundationLabel: { fr: 'Fondation de confiance et de contexte', en: 'Trust and context foundation' },
  signature: [
    { text: { fr: 'Une intelligence qui suit', en: 'An intelligence that follows' }, accent: false },
    { text: { fr: 'la relation, pas l’interface.', en: 'the relationship, not the interface.' }, accent: true },
  ],
}

export type ServiceKey = 'requests' | 'comms' | 'collect' | 'permits' | 'leisure' | 'meters'

export const atnaServices: { key: ServiceKey; side: 'left' | 'right'; title: Bi; desc: Bi }[] = [
  { key: 'requests', side: 'left', title: { fr: 'Requêtes', en: 'Requests' }, desc: { fr: 'Plus de demandes traitées', en: 'More requests handled' } },
  { key: 'comms', side: 'left', title: { fr: 'Communications', en: 'Communications' }, desc: { fr: 'Des réponses cohérentes', en: 'Consistent answers' } },
  { key: 'collect', side: 'left', title: { fr: 'Collectes', en: 'Waste collection' }, desc: { fr: 'Des données de qualité', en: 'Quality data' } },
  { key: 'permits', side: 'right', title: { fr: 'Permis', en: 'Permits' }, desc: { fr: 'Des processus accélérés', en: 'Faster processes' } },
  { key: 'leisure', side: 'right', title: { fr: 'Loisirs', en: 'Recreation' }, desc: { fr: 'Un accès simplifié', en: 'Simpler access' } },
  { key: 'meters', side: 'right', title: { fr: 'Compteurs d’eau et plus', en: 'Water meters and more' }, desc: { fr: 'Des opérations plus fluides', en: 'Smoother operations' } },
]

export type FoundationKey = 'identity' | 'card' | 'consent'

export const atnaFoundation: { key: FoundationKey; label: Bi }[] = [
  { key: 'identity', label: { fr: 'Identité', en: 'Identity' } },
  { key: 'card', label: { fr: 'Carte numérique', en: 'Digital card' } },
  { key: 'consent', label: { fr: 'Profil et consentements', en: 'Profile & consent' } },
]

export type OutcomeKey = 'capacity' | 'quality' | 'teams' | 'integrated'

export const atnaOutcomes: { key: OutcomeKey; title: Bi[]; desc: Bi[] }[] = [
  {
    key: 'capacity',
    title: [{ fr: 'Plus de', en: 'More' }, { fr: 'capacité opérationnelle', en: 'operational capacity' }],
    desc: [{ fr: 'Traitez davantage,', en: 'Handle more,' }, { fr: 'plus rapidement', en: 'faster' }],
  },
  {
    key: 'quality',
    title: [{ fr: 'Une meilleure', en: 'Better' }, { fr: 'qualité de service', en: 'service quality' }],
    desc: [{ fr: 'Des usagers mieux servis', en: 'Better-served,' }, { fr: 'et bien informés', en: 'well-informed users' }],
  },
  {
    key: 'teams',
    title: [{ fr: 'Des équipes', en: 'More effective' }, { fr: 'plus efficaces', en: 'teams' }],
    desc: [{ fr: 'Moins de tâches manuelles,', en: 'Fewer manual tasks,' }, { fr: 'plus de valeur', en: 'more value' }],
  },
  {
    key: 'integrated',
    title: [{ fr: 'Une intelligence intégrée', en: 'Intelligence built into' }, { fr: 'à vos systèmes', en: 'your systems' }],
    desc: [{ fr: 'Sûre, encadrée', en: 'Secure, governed' }, { fr: 'et évolutive', en: 'and scalable' }],
  },
]
